<!--地图-->
<template>
  <div id="mapContainer" class="map-of-china"></div>
</template>

<script>
  import echarts from 'echarts'
  import 'echarts/map/js/china.js' //引入中国地图数据
  export default {
    data() {
      return {
        memberlist: '',
        selectProvince: [],
        avaProvince: [],
        selectCity: [{
            name: '北京'
          },
          {
            name: '天津',
          },
          {
            name: '青岛'
          },
          {
            name: '厦门'
          },
          {
            name: '广州'
          },
          {
            name: '新疆'
          },
          {
            name: '成都'
          },
          {
            name: '南京'
          },
          {
            name: '哈尔滨'
          },
          {
            name: '乌鲁木齐'
          }
        ],
      };
    },

    components: {},

    mounted() {
      this.getMemberList();

      // this.drawMap();
      // window.onresize = () => {
      //   return (() => {
      //     this.drawMap();
      //   })();
      // };

      const that = this
      window.addEventListener('resize', function() {
        that.drawMap();
      })

    },

    // watch: {
    //   screenWidth(val) {
    //     // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
    //     if (!this.timer) {
    //       // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
    //       this.screenWidth = val
    //       this.timer = true
    //       let that = this
    //       setTimeout(function() {
    //         // 打印screenWidth变化的值
    //         // console.log(that.screenWidth)
    //         // this.drawMap();
    //         that.timer = false
    //       }, 400)
    //     }
    //   }
    // },

    methods: {
      // 获取成员列表
      getMemberList() {
        this.instance.get('/api/memberlist').then(res => {
          if (res.status == 200) {
            // console.log('data', res.data)
            let data = res.data
            let itemList = res.data.memberlist
            let originalList = []
            let uniqueList = []
            let jsonList = []
            this.memberlist = data.memberlist;
            itemList.forEach(item => {
              originalList.push(item.province)
            })
            uniqueList = this.unique(originalList)
            this.avaProvince = uniqueList
            uniqueList.forEach(side => {
              // console.log('side',side)
              jsonList.push({
                name: side,
                value: 100,
                itemStyle: {
                  areaColor: '#76819C'
                },
                emphasis: {
                  itemStyle: {
                    areaColor: '#F8BF09'
                  }
                }
              })
            })

            this.selectProvince = jsonList
            this.drawMap();



            // console.log('pi',this.provincesInvolved)


            // {
            //   name: '广东',
            //   value: 100,
            //   itemStyle: {
            //     areaColor: '#3C4A5D'
            //   },
            //   emphasis: {
            //     itemStyle: {
            //       areaColor: '#F8BF09'
            //     }
            //   }
            // },
          }

        })
      },

      unique(arr) {
        return Array.from(new Set(arr))
      },







      drawMap() {
        let cityList = []
        let provincesList = []
        let mapAvaProvince = []
        let mapMemberlist = []
        // for (let city in this.ChinaCity.city) {
        //   // console.log('city', city)
        //   cityList.push({
        //     name: city
        //   })
        // }
        cityList = this.selectCity
        provincesList = this.selectProvince
        mapAvaProvince = this.avaProvince
        mapMemberlist = this.memberlist
        // console.log('pl',provincesList)


        // var geoCoordMap = { //自定义城市坐标
        //   "郑州": [113.62, 34.75],
        //   "西安": [108.95, 34.27],
        //   "青岛": [120.33, 36.07],
        //   "宁波": [121.56, 29.86],
        //   "芜湖": [118.38, 31.33]
        // };
        var geoCoordMap = this.ChinaCity.city
        var convertData = function(data) {
          var res = [];
          for (var i = 0; i < data.length; i++) {
            var geoCoord = geoCoordMap[data[i].name];
            if (geoCoord) {
              res.push({
                name: data[i].name,
                value: geoCoord.concat(data[i].value)
              });
            }
          }
          return res;
        };
        var chartOption = {
          // geo配置详解： https://echarts.baidu.com/option.html#geo
          geo: { // 地理坐标系组件用于地图的绘制
            map: 'china', // 表示中国地图
            // roam: true, // 是否开启鼠标缩放和平移漫游
            zoom: 1, // 当前视角的缩放比例（地图的放大比例）
            label: {
              show: false
            },
            // regions: [{ //隐藏南海区域
            // 	name: '南海诸岛',
            // 	value: 0,
            // 	itemStyle: {
            // 		normal: {
            // 			opacity: 0,
            // 			label: {
            // 				show: false
            // 			}
            // 		}
            // 	}
            // }],
            itemStyle: {
              normal: {
                areaColor: '#BFCDDC',
                borderColor: '#FFFFFF'
              },
              emphasis: {
                borderWidth: 0,
                borderColor: '#F8BF09',
                areaColor: "#F8BF09",
                shadowBlur: 20,
                shadowColor: 'rgba(145, 194, 215, 0.5)'
              }
            }
          },

          tooltip: {
            trigger: 'item',
            triggerOn: 'mousemove',
            enterable: true,
            position: 'inside',
            // position:[10,10],
            renderMode: 'html',
            backgroundColor: '#FFFFFF',
            formatter: function(params) {
              // console.log('params', params)
              // var aHref = `<a href="/memberdetail?id=10" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">中国科学院新疆理化技术研究所</a>`
              var aHref = ''
              if (mapAvaProvince.indexOf(params.name)!=-1) {
                // console.log('list',mapMemberlist)
                mapMemberlist.forEach(item=>{
                  if(item.province==params.name)
                  {
                    aHref = aHref+'<a href="/memberdetail?id='+item.id+'" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">'+item.name+'</a>'
                  }
                });
                // console.log('ah',aHref)
                // return `<a href="/memberdetail?id=10" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">中国科学院新疆理化技术研究所</a>`
              }
              // aHref = '`'+aHref+'`'
              return aHref

              // if (params.name == '新疆') {
              //   return `<a href="/memberdetail?id=10" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">中国科学院新疆理化技术研究所</a>`
              // }
              // if (params.name == '广东') {
              //   return `<a href="/memberdetail?id=6" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">中国广州分析测试中心</a>`
              // }
              // if (params.name == '黑龙江') {
              //   return `<a href="/memberdetail?id=9" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">哈尔滨市环境监测中心站</a>`
              // }
              // if (params.name == '北京') {
              //   return `<a href="/memberdetail?id=5" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">防化研究院分析化学实验室</a>
              //           <a href="/memberdetail?id=8" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">军事医学研究院毒物分析实验室</a>`
              // }
              // if (params.name == '福建') {
              //   return `<a href="/memberdetail?id=11" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">厦门大学化学化工学院谱学分析与仪器实验室</a>`
              // }
              // if (params.name == '江苏') {
              //   return `<a href="/memberdetail?id=12" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">南京理工大学化学化工学院分析中心</a>`
              // }
              // if (params.name == '天津') {
              //   return `<a href="/memberdetail?id=13" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">天津海关工业产品安全技术中心危险品检测室</a>
              //           <a href="/memberdetail?id=14" style="pointer-events:auto;display:block;padding:5px 10px;color:#000;text-decoration: underline;">中检验检疫科学研究院化学品安全研究所实验室</a>`
              // }
            }
          },

          series: [
            // 散点配置
            {
              name: '计划单列市',
              // type: ['effectScatter','map'], //影响散点
              type: 'effectScatter', //影响散点

              // _________________________________________________
              // mapType:'china',
              // zoom:1,

              // ________________________________________________
              coordinateSystem: 'geo',
              symbolSize: 12,
              showEffectOn: 'render',
              rippleEffect: {
                brushType: 'stroke'
              },
              hoverAnimation: true,
              label: {
                normal: {
                  color: '#3cfbf0',
                  formatter: '{b}',
                  position: 'right',
                  show: false
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#3cfbf0',
                  shadowBlur: 1,
                  shadowColor: '#333',

                  // ________________________________________________
                  // areaColor: '#ADB9CA',
                  // borderColor: '#FFFFFF',
                  // borderWidth: 1,
                  // borderType: 'solid',
                  // label: {
                  //   show: false
                  // }
                  // ________________________________________________
                },

                // ________________________________________________

                // emphasis: {
                //   areaColor: '#ADB9CA',
                //   label: {
                //     show: false
                //   }
                // }
                // ________________________________________________
              },

              data: convertData(cityList),
            },

            // map地图配置
            {
              name: 'members',
              type: 'map',
              mapType: 'china',
              // roam: true,
              zoom: 1,
              // scaleLimit:{
              //   min:1,
              //   max:2
              // },
              itemStyle: {
                normal: {
                  areaColor: '#BFCDDC',
                  borderColor: '#FFFFFF',
                  borderWidth: 1,
                  borderType: 'solid',
                  label: {
                    show: false
                  }
                },
                emphasis: {
                  areaColor: '#BFCDDC',
                  label: {
                    show: false
                  }
                }
              },
              // selectedMode:'single',
              // markPoint: {
              //   symbol: `image://${star}`,
              //   symbolSize: 20,
              // },

              data: provincesList,
            }


          ],

        }



        // 初始化
        if (document.getElementById('mapContainer') == null) {
          return false
        } else {
          let myMap = this.$echarts.init(document.getElementById('mapContainer'));
          // var myMap = this.$echarts.init(document.getElementsByClassName('map-of-china'));
          //  配置地图参数


          //传入参数
          // myMap.setOption(option, true);
          myMap.setOption(chartOption, true);
          window.onresize = myMap.resize;
          // myMap.off('click');
          // myMap.on('click', function (params) {
          //   console.log(params);
          // });
        }

      },
    },

  }
</script>
<style scoped>
  #mapContainer {
    position: relative;
    width: 100%;
    height: 33.3vw;
  }

  .map-of-china {}

  /* .map-of-china{
    position: relative;
    width: 100%;
    height: 100%;
  } */

  /* @media screen and (max-width:1200px){
    .main{
      position: relative;
      top: 5vw;
    }
    .map-of-china{
      width: 80%;
      height: 80%;
    }
  }*/
</style>
}
}*/
</style>



// WEBPACK FOOTER //
// src/components/Scatter.vue